import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Entry } from 'contentful';
import { FileAssetsTableSectionComponent } from 'src/app/component/shared/file-assets-table-section/file-assets-table-section.component';
import { FileAssetsPage } from 'src/app/model/page/group/api-docs/file-assets-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-file-assets-page',
  templateUrl: './file-assets-page.component.html',
  styleUrls: ['./file-assets-page.component.scss']
})
export class FileAssetsPageComponent implements OnInit {
  @Input() pageTitle = '';

  @ViewChild(FileAssetsTableSectionComponent)
  fileAssetsTableSectionComponent!: FileAssetsTableSectionComponent;

  fileAssetsPage: FileAssetsPage = {} as FileAssetsPage;
  isNoteSectionExist: boolean = false;
  isindexXMLSamplesSectionExist: boolean = false;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInitWithPageTitle(pageTitle: string) {
    // console.log('>>>> >>>> FileAssetsPageComponent invoked ngOnInitWithPageTitle');
    this.pageTitle = pageTitle;
    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'file-asserts') {
        this.fileAssetsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.isNoteSectionExist = false;
    const query = { 'fields.title': this.pageTitle };

    this.contentfulService.getPageContentWithEntries(query).then((fileAssetsPageEntries) => {
      this.fileAssetsPage.needMoreSamplesSections = [];
      this.fileAssetsPage.tableSections = [];
      this.fileAssetsPage.indexXMLSamplesSection = [];

      this.mapBanners(fileAssetsPageEntries, query);
      this.sharedDataService.addSharedData(this.fileAssetsPage.banner);
      this.mapNoteSections(fileAssetsPageEntries);
      this.mapSections(fileAssetsPageEntries);
      this.mapTableSections(fileAssetsPageEntries);
    });
  }

  private mapBanners(fileAssetsPageEntries: Entry<any>[], query: any) {
    if (fileAssetsPageEntries) {
      fileAssetsPageEntries
        .filter((entry) => ModelValidator.isBanner(entry))
        .forEach((entry) => {
          this.mapEntryToBanner(entry, query);
        });
    }
  }

  private mapEntryToBanner(entry: Entry<any>, query: any) {
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    let imageDetails: any = entry.fields['image'];
    this.fileAssetsPage.banner = {
      title: pageTitle,
      subTitle:  entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
    };
    // console.log('title of banner', this.fileAssetsPage.banner.title);
    this.fileAssetsTableSectionComponent.ngOnInit();
    this.mapLastUpdatedAndEditorDetailsToBanner(query);
  }

  private mapLastUpdatedAndEditorDetailsToBanner(query: any) {
    this.contentfulService.getPageContentWithItems(query).then((fileAssetsPageEntries) => {
      fileAssetsPageEntries.forEach((entry: any) => {
        let editorDetails = entry.fields?.editorDetails?.split('#') || [];
        if (Array.isArray(editorDetails)) {
          this.fileAssetsPage.banner.editorEmail = editorDetails?.pop();
          this.fileAssetsPage.banner.editorShortName = editorDetails?.pop();
          this.fileAssetsPage.banner.editorFullName = editorDetails?.pop();
          this.fileAssetsPage.banner.lastUpdated = entry.fields?.lastUpdated;
          this.fileAssetsPage.banner.url = entry.fields?.url;
          this.fileAssetsPage.htmlTitle = entry.fields.htmlTitle;
        }
      });
    });
  }

  private mapNoteSections(fileAssetsPageEntries: Entry<any>[]) {
    fileAssetsPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapNote(entry);
      });
  }

  private mapNote(entry: Entry<any>) {


    this.isNoteSectionExist = true;

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.fileAssetsPage.needMoreSamplesSections?.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string
    });
  }

  private mapSections(fileAssetsPageEntries: Entry<any>[]) {
    fileAssetsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapIndexXMLSamplesSection(entry);
      });
  }

  private mapIndexXMLSamplesSection(entry: Entry<any>) {
    this.isindexXMLSamplesSectionExist = true;

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.fileAssetsPage.indexXMLSamplesSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string
    });
  }

  private mapTableSections(fileAssetsPageEntries: Entry<any>[]) {
    fileAssetsPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapTables(entry);
      });
  }

  private mapTables(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    let table = {
      title: givenTitle.split('#').pop(),
      body: entry.fields['body'] as string,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string
    };
    this.fileAssetsPage.tableSections!.push(table);
    this.fileAssetsPage.tableSections.sort((a, b) => a.order - b.order);
  }
}
